<template>
  <div>
    <div class="头部样式 pl-10 pr-10">
      <div class="c-white">
        <span class="f-18">深圳市中浩易汽车租赁有限公司</span>
        <i style="padding: 6px;"></i>
        <span class="f-12">综合 &middot; 办公 &middot; 管理系统&emsp;V1.3.0</span>
        <i style="padding: 6px;"></i>
        <!-- <span class="f-12">{{ date }}</span> -->
        <el-link class="f-r" :underline="false" @click="退出登录()" type="">退出</el-link>
        <i class="f-r" style="padding: 6px;"></i>
        <el-link @click="打开员工信息设置()" class="f-r" :underline="false" type="">{{ 姓名 }} ({{ 部门 }}-{{ 职务 }})</el-link>
        <div class="f-r">
          <el-link @click="打开员工信息设置()" class="f-r" :underline="false" type="">
            <el-avatar :size="40" :src="头像"></el-avatar>
          </el-link>
        </div>
        <el-button class="f-r mt-5 mr-5 f-14" type="warning" size="mini" @click="显示用户设置 = true">设置</el-button>
      </div>
    </div>

    <el-dialog title="全局用户默认设置" :visible.sync="显示用户设置" top="4vh" width="60%">
      <el-form :model="用户设置表单" ref="用户设置表单" label-width="auto">
        <el-row>
          <el-col :span="12">
            <el-form-item label="查询表单尺寸" prop="查询表单尺寸" required>
              <el-select v-model="用户设置表单.查询表单尺寸" size="small">
                <el-option label="大型" value="大型"></el-option>
                <el-option label="中型" value="medium"></el-option>
                <el-option label="小型" value="small"></el-option>
                <el-option label="最小型" value="mini"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="操作按钮尺寸" prop="操作按钮尺寸" required>
              <el-select v-model="用户设置表单.操作按钮尺寸" size="small">
                <el-option label="最大型" value="f-30"></el-option>
                <el-option label="超大型" value="f-26"></el-option>
                <el-option label="大型" value="f-24"></el-option>
                <el-option label="中大型" value="f-22"></el-option>
                <el-option label="中型" value="f-20"></el-option>
                <el-option label="中小型" value="f-18"></el-option>
                <el-option label="小型" value="f-16"></el-option>
                <el-option label="超小型" value="f-14"></el-option>
                <el-option label="最小型" value="f-12"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item label="数据统计尺寸" prop="数据统计尺寸" required>
              <el-select v-model="用户设置表单.数据统计尺寸" size="small">
                <el-option label="最大型" value="f-30"></el-option>
                <el-option label="超大型" value="f-26"></el-option>
                <el-option label="大型" value="f-24"></el-option>
                <el-option label="中大型" value="f-22"></el-option>
                <el-option label="中型" value="f-20"></el-option>
                <el-option label="中小型" value="f-18"></el-option>
                <el-option label="小型" value="f-16"></el-option>
                <el-option label="超小型" value="f-14"></el-option>
                <el-option label="最小型" value="f-12"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="编辑表单尺寸" prop="编辑表单尺寸" required>
              <el-select v-model="用户设置表单.编辑表单尺寸" size="small">
                <el-option label="大型" value="大型"></el-option>
                <el-option label="中型" value="medium"></el-option>
                <el-option label="小型" value="small"></el-option>
                <el-option label="最小型" value="mini"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item label="数据表格高度" prop="数据表格高度" required>
              <el-select v-model="用户设置表单.数据表格高度" size="small">
                <el-option label="400" :value="400"></el-option>
                <el-option label="600" :value="600"></el-option>
                <el-option label="750" :value="750"></el-option>
                <el-option label="999" :value="999"></el-option>
                <el-option label="9999" :value="9999"></el-option>
                <el-option label="99999" :value="99999"></el-option>
                <el-option label="999999" :value="999999"></el-option>
                <el-option label="9999999" :value="9999999"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="数据表格每页条数" prop="数据表格每页条数" required>
              <el-select v-model="用户设置表单.数据表格每页条数" size="small">
                <el-option label="50" :value="50"></el-option>
                <el-option label="100" :value="100"></el-option>
                <el-option label="200" :value="200"></el-option>
                <el-option label="500" :value="500"></el-option>
                <el-option label="1000" :value="1000"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item label="编辑表单号码尺寸" prop="编辑表单号码尺寸" required>
              <el-select v-model="用户设置表单.编辑表单号码尺寸" size="small">
                <el-option label="最大型" value="f-50"></el-option>
                <el-option label="超大型" value="f-40"></el-option>
                <el-option label="大型" value="f-30"></el-option>
                <el-option label="中大型" value="f-26"></el-option>
                <el-option label="中型" value="f-24"></el-option>
                <el-option label="中小型" value="f-22"></el-option>
                <el-option label="小型" value="f-20"></el-option>
                <el-option label="超小型" value="f-18"></el-option>
                <el-option label="最小型" value="f-16"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="编辑表单按钮尺寸" prop="编辑表单按钮尺寸" required>
              <el-select v-model="用户设置表单.编辑表单按钮尺寸" size="small">
                <el-option label="最大型" value="f-30"></el-option>
                <el-option label="超大型" value="f-26"></el-option>
                <el-option label="大型" value="f-24"></el-option>
                <el-option label="中大型" value="f-22"></el-option>
                <el-option label="中型" value="f-20"></el-option>
                <el-option label="中小型" value="f-18"></el-option>
                <el-option label="小型" value="f-16"></el-option>
                <el-option label="超小型" value="f-14"></el-option>
                <el-option label="最小型" value="f-12"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item label="数据表格类型" prop="数据表格类型" required>
              <el-select v-model="用户设置表单.数据表格类型" size="small" disabled>
                <el-option label="聚合型" value="聚合型"></el-option>
                <el-option label="多列型" value="多列型"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12"></el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="显示用户设置 = false">取 消</el-button>
        <el-button type="primary" @click="保存用户设置()" :loading="保存用户设置中">确 定</el-button>
      </div>
    </el-dialog>

    <el-drawer title="显示员工信息设置" :visible.sync="显示员工信息设置" :with-header="false" direction="ttb" size="95%">
      <el-form :model="员工信息设置表单" ref="员工信息设置表单" :rules="员工信息设置表单验证" :size="用户设置表单.编辑表单尺寸" label-width="auto">
        <mianban header="员工信息" yangshi="panel-primary" class="ma-10">
          <div :class="'text-c mb-10 '+用户设置表单.编辑表单号码尺寸">
            <span class="c-orange ziti-b">{{ 员工信息设置表单.姓名 }}信息修改</span>
          </div>
          <div>
            <el-row>
              <el-col :span="6">
                <el-form-item label="姓名" prop="姓名" required>
                  <el-input v-model="员工信息设置表单.姓名" placeholder="请输入姓名" :disabled="true"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="密码" prop="密码" required>
                  <el-input v-model="员工信息设置表单.密码" placeholder="请输入密码"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="手机号码" prop="手机号码" required>
                  <el-input v-model="员工信息设置表单.手机号码" placeholder="请输入手机号码"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="身份证" prop="身份证" required>
                  <el-input v-model="员工信息设置表单.身份证" placeholder="请输入身份证"></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="6">
                <el-form-item label="性别" prop="性别" required>
                  <el-select v-model="员工信息设置表单.性别" placeholder="性别" style="width: 100%;">
                    <el-option label="男" value="男"></el-option>
                    <el-option label="女" value="女"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="学历" prop="学历" required>
                  <el-select v-model="员工信息设置表单.学历" placeholder="学历" style="width: 100%;">
                    <el-option label="小学" value="小学"></el-option>
                    <el-option label="初中" value="初中"></el-option>
                    <el-option label="中专" value="中专"></el-option>
                    <el-option label="高中" value="高中"></el-option>
                    <el-option label="大专" value="大专"></el-option>
                    <el-option label="本科" value="本科"></el-option>
                    <el-option label="研究生" value="研究生"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="住宿" prop="住宿" required>
                  <el-select v-model="员工信息设置表单.住宿" placeholder="住宿" style="width: 100%;">
                    <el-option label="外宿" value="外宿"></el-option>
                    <el-option label="住公司" value="住公司"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="驾驶证号" prop="驾驶证号" required>
                  <el-input v-model="员工信息设置表单.驾驶证号" placeholder="请输入驾驶证号"></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="6">
                <el-form-item label="出生日期" prop="出生日期" required>
                  <el-date-picker v-model="员工信息设置表单.出生日期" type="date" value-format="yyyy-MM-dd" format="yyyy-MM-dd"
                    placeholder="出生日期" style="width: 100%;"></el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="紧急联系人" prop="紧急联系人" required>
                  <el-input v-model="员工信息设置表单.紧急联系人" placeholder="请输入紧急联系人"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="婚姻" prop="婚姻" required>
                  <el-select v-model="员工信息设置表单.婚姻" placeholder="婚姻" style="width: 100%;">
                    <el-option label="未婚" value="未婚"></el-option>
                    <el-option label="已婚" value="已婚"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="所属区域" prop="所属区域" required>
                  <el-select v-model="员工信息设置表单.所属区域" placeholder="所属区域" style="width: 100%;">
                    <el-option label="深圳" value="深圳"></el-option>
                    <el-option label="东莞" value="东莞"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="6">
                <el-form-item label="所属公司" prop="所属公司" required>
                  <el-input v-model="员工信息设置表单.所属公司" placeholder="请输入所属公司"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="籍贯" prop="籍贯" required>
                  <el-input v-model="员工信息设置表单.籍贯" placeholder="请输入籍贯"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="现居住地" prop="现居住地" required>
                  <el-input v-model="员工信息设置表单.现居住地" placeholder="请输入现居住地"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="手机短号">
                  <el-input v-model="员工信息设置表单.手机短号" placeholder="请输入手机短号"></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="24">
                <el-form-item label="备注">
                  <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 10 }" v-model="员工信息设置表单.备注"
                    placeholder="请输入备注"></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="8">
                <el-form-item label="头像">
                  <ImgCutter @cutDown="cutDown" :cutWidth="400" :cutHeight="400" rate="1:1"></ImgCutter>
                  <el-avatar class="mt-5" shape="square" :size="100" :src="员工信息设置表单.头像"></el-avatar>
                </el-form-item>
              </el-col>
            </el-row>
          </div>

          <div class="text-c mt-10 mb-10">
            <el-button @click="显示员工信息设置 = false" :class="用户设置表单.编辑表单按钮尺寸" size="mini" type="danger">关闭页面</el-button>
            <el-button @click="保存员工信息()" :class="用户设置表单.编辑表单按钮尺寸" size="mini" type="primary">保存员工信息</el-button>
          </div>
        </mianban>


      </el-form>
    </el-drawer>
  </div>
</template>

<script>
  import ImgCutter from 'vue-img-cutter';
  export default {
    components: {
      ImgCutter
    },
    data() {
      return {
        //用户设置参数: JSON.parse(localStorage.getItem('用户设置参数')),
        date: new Date().toLocaleString(),
        姓名: '',
        部门: '',
        职务: '',
        头像: '',
        timer: '',

        显示员工信息设置: false,
        员工信息设置表单: {
          姓名: '',
          密码: '',
          性别: '',
          学历: '',
          住宿: '',
          手机号码: '',
          手机短号: '',
          出生日期: '',
          籍贯: '',
          现居住地: '',
          身份证: '',
          驾驶证号: '',
          所属公司: '',
          所属区域: '',
          婚姻: '',
          头像: '',
          紧急联系人: '',
          备注: '',
        },
        员工信息设置表单验证: {
          姓名: [{
            required: true,
            message: '请输入姓名',
            trigger: 'blur'
          }],
          密码: [{
            required: true,
            message: '请输入密码',
            trigger: 'blur'
          }],
          性别: [{
            required: true,
            message: '请输入性别',
            trigger: 'blur'
          }],
          学历: [{
            required: true,
            message: '请输入学历',
            trigger: 'blur'
          }],
          住宿: [{
            required: true,
            message: '请输入住宿',
            trigger: 'blur'
          }],
          手机号码: [{
            required: true,
            message: '请输入手机号码',
            trigger: 'blur'
          }],
          出生日期: [{
            required: true,
            message: '请输入出生日期',
            trigger: 'blur'
          }],
          籍贯: [{
            required: true,
            message: '请输入籍贯',
            trigger: 'blur'
          }],
          现居住地: [{
            required: true,
            message: '请输入现居住地',
            trigger: 'blur'
          }],
          身份证: [{
            required: true,
            message: '请输入身份证',
            trigger: 'blur'
          }],
          驾驶证号: [{
            required: true,
            message: '请输入驾驶证号',
            trigger: 'blur'
          }],
          所属公司: [{
            required: true,
            message: '请输入所属公司',
            trigger: 'blur'
          }],
          所属区域: [{
            required: true,
            message: '请输入所属区域',
            trigger: 'blur'
          }],
          婚姻: [{
            required: true,
            message: '请输入婚姻',
            trigger: 'blur'
          }],
          头像: [{
            required: true,
            message: '请输入头像',
            trigger: 'blur'
          }],
          紧急联系人: [{
            required: true,
            message: '请输入紧急联系人',
            trigger: 'blur'
          }],
        },

        显示用户设置: false,
        保存用户设置中: false,
        用户设置表单: {
          查询表单尺寸: '',
          操作按钮尺寸: '',
          数据统计尺寸: '',
          数据表格类型: '',
          数据表格高度: '',
          数据表格每页条数: '',
          编辑表单号码尺寸: '',
          编辑表单按钮尺寸: '',
          编辑表单尺寸: ''
        }
      };
    },
    created: function() {
      this.用户设置();
      this.当前系统时间();
      this.自动登录();
    },
    beforeDestroy: function() {
      if (this.timer) {
        clearInterval(this.timer); //在Vue实例销毁前，清除定时器
      }
    },
    methods: {
      用户设置() {
        this.$http.post('get/shezhi/list').then(返回数据 => {
          this.用户设置表单.查询表单尺寸 = 返回数据.用户设置数据.查询表单尺寸;
          this.用户设置表单.操作按钮尺寸 = 返回数据.用户设置数据.操作按钮尺寸;
          this.用户设置表单.数据统计尺寸 = 返回数据.用户设置数据.数据统计尺寸;
          this.用户设置表单.数据表格类型 = 返回数据.用户设置数据.数据表格类型;
          this.用户设置表单.数据表格高度 = 返回数据.用户设置数据.数据表格高度;
          this.用户设置表单.数据表格每页条数 = 返回数据.用户设置数据.数据表格每页条数;
          this.用户设置表单.编辑表单号码尺寸 = 返回数据.用户设置数据.编辑表单号码尺寸;
          this.用户设置表单.编辑表单按钮尺寸 = 返回数据.用户设置数据.编辑表单按钮尺寸;
          this.用户设置表单.编辑表单尺寸 = 返回数据.用户设置数据.编辑表单尺寸;
          if (localStorage.getItem('用户设置参数')) {
            if (JSON.parse(localStorage.getItem('用户设置参数')).用户设置版本 != 返回数据.用户设置数据.用户设置版本) {
              localStorage.setItem('用户设置参数', JSON.stringify(返回数据.用户设置数据));
            }
          } else {
            localStorage.setItem('用户设置参数', JSON.stringify(返回数据.用户设置数据));
          }
        });
        //localStorage.removeItem("用户设置参数");
        console.log(localStorage.getItem('用户设置参数'));
      },
      当前系统时间() {
        let _this = this;
        this.timer = setInterval(function() {
          _this.date = new Date().toLocaleString();
        });
      },
      自动登录() {
        localStorage.setItem('shebei', 'liulanqi_diannao');
        localStorage.setItem('renzhengma', '37c1fcf4ab61593978fb0bda44340953');
        var 登录口令 = localStorage.getItem('登录口令');
        var 登录口令编号 = localStorage.getItem('登录口令编号');
        if (登录口令 !== '' && 登录口令编号 !== '') {
          this.$http.post('login/auto2').then(response => {
            //console.log(response);
            this.姓名 = response.姓名;
            this.部门 = response.部门;
            this.职务 = response.职务;
            this.头像 = response.头像;
            //this.$message.success(response.信息);
          });
        }
      },
      退出登录() {
        this.$confirm('确定要退出登录吗?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
          .then(() => {
            localStorage.removeItem('登录口令');
            localStorage.removeItem('登录口令编号');
            this.$message({
              type: 'success',
              message: '退出成功!'
            });
            window.location.replace('login.html');
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消'
            });
          });
      },
      保存用户设置() {
        this.保存用户设置中 = true;
        setTimeout(() => {
          this.保存用户设置中 = false;
        }, 5000);
        this.$http
          .post('get/shezhi/edit', {
            查询表单尺寸: this.用户设置表单.查询表单尺寸,
            操作按钮尺寸: this.用户设置表单.操作按钮尺寸,
            数据统计尺寸: this.用户设置表单.数据统计尺寸,
            数据表格类型: this.用户设置表单.数据表格类型,
            数据表格高度: this.用户设置表单.数据表格高度,
            数据表格每页条数: this.用户设置表单.数据表格每页条数,
            编辑表单号码尺寸: this.用户设置表单.编辑表单号码尺寸,
            编辑表单按钮尺寸: this.用户设置表单.编辑表单按钮尺寸,
            编辑表单尺寸: this.用户设置表单.编辑表单尺寸
          })
          .then(返回数据 => {
            localStorage.setItem('用户设置参数', JSON.stringify(返回数据.用户设置数据));
            this.显示用户设置 = false;
            this.保存用户设置中 = false;
            this.$message.success(返回数据.信息);
            setTimeout(() => {
              location.reload();
            }, 800);
          });
      },
      打开员工信息设置() {
        this.显示员工信息设置 = true;
        this.$http.post('yuangong/yuangongxinxi/get_yg').then(返回数据 => {
          this.员工信息设置表单.姓名 = 返回数据.员工信息.姓名;
          this.员工信息设置表单.密码 = 返回数据.员工信息.密码;
          this.员工信息设置表单.性别 = 返回数据.员工信息.性别;
          this.员工信息设置表单.学历 = 返回数据.员工信息.学历;
          this.员工信息设置表单.住宿 = 返回数据.员工信息.住宿;
          this.员工信息设置表单.手机号码 = 返回数据.员工信息.手机号码;
          this.员工信息设置表单.手机短号 = 返回数据.员工信息.手机短号;
          this.员工信息设置表单.出生日期 = 返回数据.员工信息.出生日期;
          this.员工信息设置表单.籍贯 = 返回数据.员工信息.籍贯;
          this.员工信息设置表单.现居住地 = 返回数据.员工信息.现居住地;
          this.员工信息设置表单.身份证 = 返回数据.员工信息.身份证;
          this.员工信息设置表单.驾驶证号 = 返回数据.员工信息.驾驶证号;
          this.员工信息设置表单.所属公司 = 返回数据.员工信息.所属公司;
          this.员工信息设置表单.所属区域 = 返回数据.员工信息.所属区域;
          this.员工信息设置表单.婚姻 = 返回数据.员工信息.婚姻;
          this.员工信息设置表单.头像 = 返回数据.员工信息.头像;
          this.员工信息设置表单.紧急联系人 = 返回数据.员工信息.紧急联系人;
          this.员工信息设置表单.备注 = 返回数据.员工信息.备注;
        });
      },
      cutDown(文件) {
        console.log(文件);
        this.$http
          .post('gg/shangchuan/touxiang_data', {
            图片编码: 文件.dataURL
          })
          .then(返回数据 => {
            console.log(返回数据);
            this.员工信息设置表单.头像 = 返回数据.头像;
            this.$message.success(返回数据.信息);
          });
      },
      保存员工信息() {
        this.$refs['员工信息设置表单'].validate(valid => {
          if (valid) {
            this.$http
              .post('yuangong/yuangongxinxi/edit_yg', {
                密码: this.员工信息设置表单.密码,
                性别: this.员工信息设置表单.性别,
                学历: this.员工信息设置表单.学历,
                住宿: this.员工信息设置表单.住宿,
                手机号码: this.员工信息设置表单.手机号码,
                手机短号: this.员工信息设置表单.手机短号,
                出生日期: this.员工信息设置表单.出生日期,
                籍贯: this.员工信息设置表单.籍贯,
                现居住地: this.员工信息设置表单.现居住地,
                身份证: this.员工信息设置表单.身份证,
                驾驶证号: this.员工信息设置表单.驾驶证号,
                所属公司: this.员工信息设置表单.所属公司,
                所属区域: this.员工信息设置表单.所属区域,
                婚姻: this.员工信息设置表单.婚姻,
                紧急联系人: this.员工信息设置表单.紧急联系人,
                备注: this.员工信息设置表单.备注,
              })
              .then(返回数据 => {
                this.$message.success(返回数据.信息);
                this.显示员工信息设置 = false;
                setTimeout(() => {
                  location.reload();
                }, 500);
              });
          } else {
            console.log('下单验证不通过，请检查下单信息是否正确!');
            return false;
          }
        });
      },

    }
  };
</script>

<style>
  .头部样式 {
    background-color: #5a98de;
    color: #333;
    line-height: 40px;
  }
</style>
